export default __webpack_public_path__ + "3fa880f00423520b5e8cfa52b2920b49.png";